// extracted by mini-css-extract-plugin
export var growableInput = "_5w-0";
export var tagContainer = "_5w-2";
export var textInput = "_5w-1";